import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import ErrorBoundary from './ErrorBoundary';

import './globals.css';
import { startInit } from './lib/poofClient';
import './styles/base.css';

// Phantom wallet auth modal a11y fix: the SDK-rendered close button has no aria-label
// and is 28x28px (below WCAG 2.5.5 40px minimum). Inline styles override CSS so we patch
// both attributes via MutationObserver when the provider container enters the DOM.
function installPhantomModalA11yFix(): void {
  const patchButtons = (root: Element): void => {
    root.querySelectorAll<HTMLButtonElement>('button').forEach((btn) => {
      if (btn.style.position !== 'absolute') return;
      if (!btn.getAttribute('aria-label')) btn.setAttribute('aria-label', 'Close');
      const w = parseFloat(btn.style.width || '0');
      if (w < 40) {
        btn.style.width = '40px';
        btn.style.height = '40px';
        btn.style.minWidth = '40px';
        btn.style.minHeight = '40px';
      }
    });
  };
  const observer = new MutationObserver(() => {
    const container = document.querySelector('[data-phantom-provider]');
    if (container) patchButtons(container);
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

if (typeof window !== 'undefined') {
  installPhantomModalA11yFix();
}

void startInit().catch((err) => {
  console.error('Failed to init app', err);
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
